<template>
    <div class="finish-changes">
      <div class="message">
        <p>We’ve sent your information to your insurance representative and they’ll be following up with you shortly.</p>
        <p>If you have any changes that need to be made to your current policy, please give us a call at (877) 668-1704.</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'FinishChanges'
  }
  </script>
  
  <style scoped>
  .finish-changes {
    text-align: center;
    padding: 15px 40px 20px 40px;
  }
  
  .message {
    max-width: 600px;
    margin: 0 auto;
    text-align: left;
  }
  
  .message p {
    margin-bottom: 20px;
  }
  </style>
  